
export const COLUMNS = [
    {
        Header: 'Naziv',
        accessor: 'name'

    },
    {
        Header: 'Kalorije',
        accessor: 'calories'
    },
    {
        Header: 'Ugljeni hidrati',
        accessor: 'carbohydrates'
    },
    {
        Header: 'Proteini',
        accessor: 'proteins',
    },
    {
        Header: 'Masti',
        accessor: 'fats',
    },
]